let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("2F69B"), load("ffEVr"), load("hhss7"), load("kUiwW")]).then(() => parcelRequire('3kPYw'));